var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "征集配方",
          fixed: "",
        },
        on: { "click-left": _vm.onClickLeft },
      }),
      _c("div", { staticStyle: { height: "60px" } }),
      _vm._l(_vm.collectionData, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "tab-box1-style van-hairline--bottom" },
          [
            _c(
              "div",
              {
                staticClass: "item-box",
                on: {
                  click: function ($event) {
                    return _vm.uploadCollectionRecipe(item)
                  },
                },
              },
              [
                _c(
                  "van-row",
                  [
                    _c(
                      "van-col",
                      {
                        staticStyle: { "border-right": "1px solid #F3F3F8" },
                        attrs: { span: "6" },
                      },
                      [
                        _c("div", { staticClass: "box-left-one" }, [
                          item.topCollection === "true"
                            ? _c("img", {
                                staticStyle: { height: "50px" },
                                attrs: {
                                  src: require("../../assets/image/zj_top.png"),
                                  alt: "",
                                },
                              })
                            : item.isNew === true
                            ? _c("img", {
                                staticStyle: { height: "50px" },
                                attrs: {
                                  src: require("../../assets/image/zj_new.png"),
                                  alt: "",
                                },
                              })
                            : _c("div", { staticStyle: { height: "50px" } }),
                        ]),
                        _c("div", [
                          item.topCollection === "true"
                            ? _c("div", { staticClass: "row-point-txt" }, [
                                _vm._v(_vm._s(item.bonusPoint)),
                              ])
                            : _c(
                                "div",
                                { staticClass: "row-point-txt-block" },
                                [_vm._v(_vm._s(item.bonusPoint))]
                              ),
                          item.topCollection === "true"
                            ? _c("div", { staticClass: "row-label-txt" }, [
                                _vm._v("奖励积分"),
                              ])
                            : _c(
                                "div",
                                { staticClass: "row-label-txt-block" },
                                [_vm._v("奖励积分")]
                              ),
                        ]),
                      ]
                    ),
                    _c("van-col", { attrs: { span: "1" } }),
                    _c("van-col", { attrs: { span: "17" } }, [
                      _c("div", [
                        _c("div", { staticClass: "box-right-one" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "600",
                                "font-size": "13px",
                                width: "50%",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                "white-space": "nowrap",
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [_vm._v(_vm._s(item.colorText))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "2%",
                                display: "flex",
                                "justify-content": "end",
                                "align-items": "center",
                                width: "42%",
                              },
                            },
                            [
                              _c("div", { staticClass: "icon-circle" }, [
                                _c(
                                  "span",
                                  { staticClass: "icon-circle-class" },
                                  [_vm._v(_vm._s(item.paintBrandName))]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "box-right-two" }, [
                          item.carBrandName && item.carModelName
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#3B8AF2",
                                    "font-size": "13px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.carBrandName) +
                                      "-" +
                                      _vm._s(item.carModelName)
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#3B8AF2",
                                    "font-size": "13px",
                                  },
                                },
                                [_vm._v(_vm._s(item.carBrandName))]
                              ),
                        ]),
                        _c("div", { staticClass: "box-right-three" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                width: "50%",
                              },
                            },
                            [
                              _vm._v(
                                "征集进度:" +
                                  _vm._s(item.uploadedNum) +
                                  "/" +
                                  _vm._s(item.collectNum)
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                                width: "45%",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upload-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadCollectionRecipe(item)
                                    },
                                  },
                                },
                                [_vm._v("立即上传")]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }